module.exports = __webpack_public_path__ + "static/media/auth-image-desktop-old.d6eb998d.svg";